import { ReactComponent as CheckCircle } from 'assets/icons/check_circle.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import clsx from 'clsx';
import Loader from 'components/Loader/Loader';

import type IContentLoader from './interfaces/IContentLoader';

import styles from './scss/ContentLoader.module.scss';

function ContentLoader({ className, title, checkIcon }: IContentLoader) {
  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.header}>
        {checkIcon ? <CheckCircle /> : <InfoIcon />}
        <p>{title}</p>
      </div>
      <div className={styles.loaderWrapper}>
        <Loader
          isPageLoading
          isFullLoader={false}
          classNameLoader={styles.loaderContent}
        />
      </div>
    </div>
  );
}

export default ContentLoader;
